<template>
    <div>
      <!-- 工具栏 -->
      <div style="margin-bottom: 10px;">
        <button @click="prevPage" :disabled="pageNum <= 1">上一页</button>
        <button @click="nextPage" :disabled="pageNum >= pageCount">下一页</button>
        <span>第 {{ pageNum }} 页 / 共 {{ pageCount }} 页</span>
        <input v-model="searchText" placeholder="搜索文本" />
        <button @click="searchInPDF">搜索</button>
      </div>
      <!-- PDF 画布 -->
      <canvas ref="pdfCanvas"></canvas>
    </div>
  </template>
  
  <script>
 import { ref, onMounted } from 'vue'
import * as pdfjsLib from 'pdfjs-dist'
import { useRoute } from 'vue-router'


// 在setup()开始时配置workerSrc
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js'

export default {
  setup() {
    const pdfDoc = ref(null)
    const pageNum = ref(1)
    const pageCount = ref(0)
    const pdfCanvas = ref(null)
    const searchText = ref('')
    const route = useRoute()
    const pdfUrl = ref(route.params.pdfUrl)
    console.log('接收到的pdfUrl:', pdfUrl.value)

    const loadPDF = async () => {
      console.log('开始加载PDF，URL:', pdfUrl.value)
      try {
        const loadingTask = pdfjsLib.getDocument(pdfUrl.value)
        pdfDoc.value = await loadingTask.promise
        console.log('PDF加载成功，总页数:', pdfDoc.value.numPages)
        pageCount.value = pdfDoc.value.numPages
        await renderPage(pageNum.value)
      } catch (error) {
        console.error('加载PDF失败:', error)
      }
    }

    const renderPage = async (num) => {
      try {
        const page = await pdfDoc.value.getPage(num)
        const viewport = page.getViewport({ scale: 1.5 })

        const canvas = pdfCanvas.value
        const context = canvas.getContext('2d')

        // 设置canvas尺寸
        canvas.height = viewport.height
        canvas.width = viewport.width

        console.log(`渲染第 ${num} 页，尺寸：${viewport.width} x ${viewport.height}`)

        const renderContext = {
          canvasContext: context,
          viewport: viewport
        }

        await page.render(renderContext).promise
      } catch (err) {
        console.error('渲染页面失败:', err)
      }
    }

    const prevPage = () => {
      if (pageNum.value <= 1) return
      pageNum.value -= 1
      renderPage(pageNum.value)
    }

    const nextPage = () => {
      if (pageNum.value >= pageCount.value) return
      pageNum.value += 1
      renderPage(pageNum.value)
    }

    const searchInPDF = () => {
      alert(`搜索文本: ${searchText.value}（功能待实现）`)
    }

    onMounted(() => {
      console.log('pdf.js版本:', pdfjsLib.version)
      loadPDF()
    })

    return {
      pageNum,
      pageCount,
      prevPage,
      nextPage,
      pdfCanvas,
      searchText,
      searchInPDF
    }
  }
}

  </script>
  